module.exports = __webpack_public_path__ + "img/cafeamplatzoeffnungszeiten.b01fa3a7.png";